export interface WindowTile {
  column: number;
  columns: number;
  row: number;
  rows: number;
}

/** Les anciens placements gauche/droite restent restaurables. */
export function restoreTile(value: unknown): WindowTile | null {
  if (value === 'left' || value === 'right')
    return { column: value === 'left' ? 0 : 1, columns: 2, row: 0, rows: 1 };
  if (typeof value !== 'object' || value === null) return null;
  const tile = value as WindowTile;
  if (![tile.column, tile.columns, tile.row, tile.rows].every(Number.isSafeInteger)) return null;
  return tile.columns > 0 &&
    tile.rows > 0 &&
    tile.column >= 0 &&
    tile.column < tile.columns &&
    tile.row >= 0 &&
    tile.row < tile.rows
    ? tile
    : null;
}

/** Une seule case par fenêtre, sans trou dans la dernière ligne. */
export function arrangeTiles(count: number): WindowTile[] {
  if (!Number.isSafeInteger(count) || count <= 0) return [];
  const columns = Math.ceil(Math.sqrt(count));
  const rows = Math.ceil(count / columns);
  return Array.from({ length: count }, (_, index) => {
    const row = Math.floor(index / columns);
    return {
      column: index % columns,
      columns: Math.min(columns, count - row * columns),
      row,
      rows,
    };
  });
}

/** Marges du placement existant : 12 px, haut 64 px, réserve verticale 176 px. */
export function tileStyle(tile: WindowTile) {
  return {
    top: `calc(${(100 * tile.row) / tile.rows}svh + ${64 - (164 * tile.row) / tile.rows}px)`,
    left: `calc(${(100 * tile.column) / tile.columns}vw + ${12 - (12 * tile.column) / tile.columns}px)`,
    width: `calc(${100 / tile.columns}vw - ${12 + 12 / tile.columns}px)`,
    height: `calc(${100 / tile.rows}svh - ${12 + 164 / tile.rows}px)`,
  };
}
